import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

import { postData, getData } from '../../config/api-connect';
import { Table, Segmented, Spin, Select, Modal, Tooltip } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Spinner from '../../components/spinner';
import './style.css';

import { BiEdit } from 'react-icons/bi';
import { IoIosClose } from 'react-icons/io';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaAngleDoubleLeft } from 'react-icons/fa';

const { Option } = Select;

const BuddyDetails = () => {
  const type = JSON.parse(localStorage.getItem('type'));
  if (type == 2) {
    var venue = JSON.parse(localStorage.getItem('selectedId'));
    if (venue == 'All') {
      venue = '';
    }
  } else {
    venue = '';
  }

  const city_wise_venue = JSON.parse(localStorage.getItem('selectedVenueId'));
  if (city_wise_venue) {
    venue = city_wise_venue;
  }
  const [buddyData, setBuddyData] = useState([]);
  const [buddyType, setBuddyType] = useState([]);
  const [buddyVenueList, setBuddyVenueList] = useState([]);
  const [buddyVenue, setBuddyVenue] = useState([]);
  const [activeStatus, setactiveStatus] = useState(true);
  const [buddyTypeId, setBuddyTypeId] = useState('');
  const [selectedId, setSelectedId] = useState(venue);
  const [buddyName, setBuddyName] = useState('');
  const [searchCntct, setSearchCntct] = useState('');
  const [serachData, setSearchData] = useState(buddyData);

  const [editStatus, setEditStatus] = useState(false);
  const [editBuddyId, setEditBuddyId] = useState('');
  const [editAccountNo, setEditAccountNo] = useState('');
  const [editIfscCode, setEditIfscCode] = useState('');
  const [editFixedpay, setEditFixedpay] = useState('');
  const [activeExpRow, setActiveExpRow] = useState();

  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const navigateToContacts = () => {
    navigate('/addBuddyData');
  };
  const navigateToOverview = () => {
    navigate('/');
  };

  const [loading, setLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    getBuddyDetails();
  }, [activeStatus, buddyTypeId, selectedId]);

  const onChangeFilter = async (value) => {
    await setSearchCntct(value);
    if (value.length >= 0) {
      const x = buddyData.filter(
        (item) =>
          item.contact_no.includes(value) || item.name.toLowerCase().includes(value.toLowerCase()),
      );
      setSearchData(x);
    }
  };

  const successModal = (message) => {
    Modal.success({
      title: message,
    });
  };
  const getBuddyDetails = () => {
    getData(
      `/finance/get_buddy_details/?is_active=${activeStatus}&buddy_type=${buddyTypeId}&venue=${selectedId}`,
    )
      .then((response) => {
        setBuddyData(response.data);
        setSearchData(response.data);
        setBuddyType(response.buddy_types);
        setBuddyVenueList(response.venues);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        alert(error.message);
      });
  };

  const getVenue = (item) => {
    setIsModalOpen(true);
    setBuddyVenue(item);
  };

  const renderItems = (item) => {
    return (
      <span>
        {item.map((items, index) => (
          <div> {index < 3 && items.name} </div>
        ))}

        {item.length > 3 && (
          <button className="venueButton" onClick={() => getVenue(item)}>
            {' '}
            View More{' '}
          </button>
        )}
      </span>
    );
  };

  const editBuddy = (item) => {
    setEditStatus(true);
    setEditBuddyId(item.id);
    setEditIfscCode(item.account_details.ifsc);
    setEditAccountNo(item.account_details.account_no);
    setEditFixedpay(item.account_details.fixed_pay);
  };
  const editSave = (id) => {
    postData('/finance/edit_buddy_details/', {
      id: id,
      account_no: editAccountNo,
      ifsc: editIfscCode,
      fixed_pay: editFixedpay,
    })
      .then((response) => {
        successModal(response.result);
        setLoading(true);
        getBuddyDetails();
      })
      .catch((error) => {
        alert(error.message);
      });
    setEditStatus(false);
  };

  const edit_AccountNo = (event) => {
    setEditAccountNo(event.target.value);
  };
  const edit_IfscCode = (event) => {
    setEditIfscCode(event.target.value);
  };

  const edit_Fixedpay = (event) => {
    setEditFixedpay(event.target.value);
  };

  const closeEdit = () => {
    setEditStatus(false);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Contact Number',
      dataIndex: 'contact_no',
      key: 'contact_no',
    },

    {
      title: 'Buddy Type',
      dataIndex: 'buddy_type',
      render: (item) => item['role'],
      key: 'buddy_type',
    },
    {
      title: 'Venue',
      dataIndex: 'venue',
      render: (item) => renderItems(item),
      key: 'venue',
    },
    Table.EXPAND_COLUMN,
  ];

  const getActiveBuddy = () => {
    setactiveStatus(true);
  };
  const getInactiveBuddy = () => {
    setactiveStatus(false);
  };

  const onChangeBuddyType = (value) => {
    setBuddyTypeId(value);
  };
  const onChangeVenue = (value) => {
    setSelectedId(value);
  };

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <>
        <div className="buddyinfo-main-container">
          <span></span>

          <div className="buddyinfo-center-container">
            <div className="buddyinfo-header">
              <span></span>
              <span> Buddy Details</span>
              <Tooltip title="Add Buddy Details">
                <span className="buddyinfo-icon-link">
                  <PlusCircleOutlined onClick={() => navigate('/buddyData')} />
                </span>
              </Tooltip>
            </div>

            <div className="buddyinfo-body">
              <div className="buddycontainer">
                <Container>
                  <Row>
                    <Col>
                      <div className="buddyinfo-filter-box" data-offset="-20">
                        <Select
                          className="buddyinfo-filter-select"
                          showSearch
                          placeholder="Search to Select"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.name.toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={onChangeVenue}
                          value={selectedId}
                          bordered={false}
                        >
                          <Option value="" key={''} name="All">
                            {' '}
                            All Venues{' '}
                          </Option>
                          {buddyVenueList.map((item, index) => (
                            <Option value={item.id} key={item.id} name={item.name}>
                              {' '}
                              {item.name}{' '}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col>
                      <div className="buddyinfo-filter-box" data-offset="-50">
                        <Select
                          className="buddyinfo-filter-select"
                          showSearch
                          placeholder="Search to Select"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.name.toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={onChangeBuddyType}
                          value={buddyTypeId}
                          bordered={false}
                        >
                          <Option value="" key={''} name="All">
                            {' '}
                            All Buddy Type{' '}
                          </Option>
                          {Object.keys(buddyType).map((item, index) => (
                            <Option value={item} key={item} name={item}>
                              {' '}
                              {buddyType[item]}{' '}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col>
                      <div className="buddyinfo-search-box">
                        <input
                          type="text"
                          onChange={(e) => {
                            onChangeFilter(e.target.value);
                          }}
                          value={searchCntct}
                          placeholder="Search buddy"
                          className="buddyinfo-search-input"
                        />
                        <AiOutlineSearch />
                      </div>
                    </Col>
                    <Col className="buddyinfo-status-col">
                      <button
                        onClick={() => setactiveStatus(true)}
                        className="buddyinfo-status-btn"
                        data-selected={activeStatus === true}
                      >
                        Active
                      </button>
                      <button
                        onClick={() => setactiveStatus(false)}
                        className="buddyinfo-status-btn"
                        data-selected={activeStatus === false}
                      >
                        Inactive
                      </button>
                    </Col>
                  </Row>
                </Container>
              </div>

              <div>
                <Table
                  rowKey="id"
                  columns={columns}
                  expandable={{
                    expandedRowRender: (record) => (
                      <Container>
                        <Row className="expansion">
                          <Col>
                            Account No :{' '}
                            {editStatus ? (
                              <input type="" text value={editAccountNo} onChange={edit_AccountNo} />
                            ) : (
                              <>{record.account_details.account_no}</>
                            )}
                          </Col>
                          <Col>
                            IFSC Code :{' '}
                            {editStatus ? (
                              <input type="" text value={editIfscCode} onChange={edit_IfscCode} />
                            ) : (
                              <>{record.account_details.ifsc}</>
                            )}
                          </Col>
                          <Col>
                            Fixed Pay :{' '}
                            {editStatus ? (
                              <input type="" text value={editFixedpay} onChange={edit_Fixedpay} />
                            ) : (
                              <>{record.account_details.fixed_pay}</>
                            )}
                          </Col>
                          <Col>
                            <span className="m-4">
                              <BiEdit size={'1.3em'} onClick={() => editBuddy(record)} />
                            </span>
                            {editStatus && (
                              <>
                                <span className="buddyinfo-mr-5">
                                  <IoIosClose size={'2em'} onClick={closeEdit} />
                                </span>
                                <Button className="buddyinfo-ml-5" onClick={() => editSave(record.id)}>
                                  Save
                                </Button>
                              </>
                            )}
                          </Col>
                        </Row>
                      </Container>
                    ),
                    expandedRowKeys: activeExpRow,
                    onExpand: (expanded, record) => {
                      const keys = [];
                      if (expanded) {
                        keys.push(record.id);
                      }
                      setActiveExpRow(keys);
                      setEditStatus(false);
                    },
                    expandRowByClick: true,
                  }}
                  dataSource={serachData}
                  pagination={{ pageSize: 20, showSizeChanger: false }}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal
          title="Venue Details "
          visible={isModalOpen}
          onCancel={handleCancel}
          okButtonProps={{ className: 'buddyinfo-modal-ok-hidden' }}
        >
          {buddyVenue.map((items) => {
            return <div className="venue">{items.name}</div>;
          })}
        </Modal>
      </>
    </Spin>
  );
};
export default BuddyDetails;
